//Order Actual hours for detailer and checker
export const GET_ORDER_ACTUAL_HRS = "GET_ORDER_ACTUAL_HRS";


export const GET_CHANGE_ORDER_DETAILS = "GET_CHANGE_ORDER_DETAILS";
export const GET_ORDER_FILES = "GET_ORDER_FILES";
export const GET_ORDER_COMMENTS_DATA = "GET_ORDER_COMMENTS_DATA";
export const GET_ORDER_FORMAT_NUMBER = "GET_ORDER_FORMAT_NUMBER";
export const GET_ORDER_CODE_SPLIT = "GET_ORDER_CODE_SPLIT";
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL";